function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_logo_svg__cls-1{fill:#44d0d2}.bespoken_logo_svg__cls-2{fill:#00c1bf}.bespoken_logo_svg__cls-3{fill:#00cf80}.bespoken_logo_svg__cls-4{fill:#00bc75}.bespoken_logo_svg__cls-5{fill:#ffb334}.bespoken_logo_svg__cls-6{fill:#ff5d00}.bespoken_logo_svg__cls-7{fill:#ffde3a}.bespoken_logo_svg__cls-8{fill:#ff9200}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_logo_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_logo_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_logo_svg__cls-1",
  d: "M24.56 0l.38 2.87-2.02 1.96-1.38.47.21-.52L24.56 0z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-1",
  d: "M21.54 5.3l1.73 5.21-4.3.95 2.57-6.16zM28.53 7.29l-3.4-2.1-1.86 5.32 5.26-3.22z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-2",
  d: "M22.04 2.84l-1.16 2.15-1.21.5 1.62-4.8.75 2.15zM21.75 4.78l-2.78 6.68-1.31.05 2.01-6.02 1.21-.5.87-.21zM25.13 5.19l-1.86 5.32-1.73-5.21 1.38-.47 2.21.36zM28.53 7.29l-5.26 3.22 4.75-.96.51-2.26zM24.46 14.57l-1.19-4.06-4.3.95 5.49 3.11z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-3",
  d: "M17.59 14.57h6.87l-5.49-3.11-1.38 3.11zM17.17 17.91h8.28l-6.75-3.34-1.53 3.34z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-4",
  d: "M24.46 14.57l.99 3.34-6.75-3.34h5.76zM18.27 17.91h7.18l-7.96 4.6.78-4.6z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-5",
  d: "M5.51 37.22L2.39 32l.81-3.1 6.49 8.56L7.18 48 5.51 37.22z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-6",
  d: "M5.51 37.22L2.39 45.4V32l3.12 5.22z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-7",
  d: "M9.69 37.46l7.8-14.95-14.3 6.38 6.5 8.57z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-6",
  d: "M20.34 37.94l-3.88-.17 1.94 7.63 1.94-7.46z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-7",
  d: "M27.55 25.05l-10.06-2.54 7.96-4.6 2.1 7.14z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-8",
  d: "M20.34 37.94l-2.85-15.43-7.8 14.95 10.65.48z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-5",
  d: "M27.55 25.05l-7.21 12.89-2.85-15.43 10.06 2.54z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-8",
  d: "M22.23 48l-1.89-10.06 7.21-12.9L22.23 48z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-6",
  d: "M1.62 29.61l1.18.81-1.41.39L0 29.85l1.62-.24z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-7",
  d: "M3.2 28.89l-.4 1.53-1.18-.81-.46-1.43 2.04.71z"
}), React.createElement("path", {
  className: "bespoken_logo_svg__cls-5",
  d: "M0 32l1.39-1.2 1.41-.38L2.39 32H0z"
})));

var SvgBespokenLogo = function SvgBespokenLogo(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 28.53 48"
  }, props), _ref, _ref2);
};

export default SvgBespokenLogo;